import { useQuery } from '@tanstack/react-query';

import SearchService from '~/services/SearchService';

const FIVE_MINUTES = 5 * 60 * 1000;

export const placeNamesByIdsQueryKeys = {
  all: ['place-names-by-ids'] as const,
  list: (placeIds: Array<string>) => [...placeNamesByIdsQueryKeys.all, placeIds] as const,
};

export function useGetPlaceNamesByIds(placeIds: Array<string>) {
  const uniquePlaceIds = Array.from(new Set(placeIds.filter(Boolean))).sort();

  return useQuery({
    enabled: uniquePlaceIds.length > 0,
    queryKey: placeNamesByIdsQueryKeys.list(uniquePlaceIds),
    staleTime: FIVE_MINUTES,
    queryFn: async () => {
      const placeEntries = await Promise.all(
        uniquePlaceIds.map(async (placeId) => {
          try {
            const response = await SearchService.getPlaceDetails(placeId);
            return [placeId, response.result.name] as const;
          } catch {
            return [placeId, placeId] as const;
          }
        }),
      );

      return Object.fromEntries(placeEntries);
    },
  });
}
